import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import getHOCDisplayName from "../service/getHOCDisplayName";
import CancelablePromiseManager from "./CancelablePromiseManager";
var withPromiseCancel = function withPromiseCancel(WrappedComponent) {
  var PromiseCancel = /*#__PURE__*/function (_PureComponent) {
    _inherits(PromiseCancel, _PureComponent);
    var _super = _createSuper(PromiseCancel);
    function PromiseCancel(props) {
      var _this;
      _classCallCheck(this, PromiseCancel);
      _this = _super.call(this, props);
      _this.cancelablePromiseManager = new CancelablePromiseManager();
      return _this;
    }
    _createClass(PromiseCancel, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cancelablePromiseManager.cleanup();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          promiseCancelHandler: {
            addCancelablePromise: this.cancelablePromiseManager.addCancelablePromise,
            createCancelablePromise: this.cancelablePromiseManager.createCancelablePromise
          }
        }));
      }
    }]);
    return PromiseCancel;
  }(PureComponent);
  PromiseCancel.displayName = getHOCDisplayName(WrappedComponent, 'PromiseCancel');
  return PromiseCancel;
};
export default withPromiseCancel;
export var propTypes = {
  promiseCancelHandler: PropTypes.shape({
    addCancelablePromise: PropTypes.func.isRequired
  }).isRequired
};